import {
  buildDebts,
  buildFixed,
  buildFlexible,
  buildIncome,
  buildFixedOther,
  dumpSection,
} from "../../domain/entities/mapping";
import { toMoney } from "../../domain/entities/money";
import { deriveFinancialStatementMode } from "../../domain/entities/mode";
import {
  computeTotals,
  disposableIncome as calcDisposable,
} from "../../domain/entities/calculators";
import {
  FinancialStatementResponseDto,
  FinancialStatementView,
} from "../dto/FinancialStatement";
import { createAboutYou } from "../../domain/entities/household";

export class FinancialUtil {
  public static toViewModel(
    dto: FinancialStatementResponseDto,
  ): FinancialStatementView {
    const income = buildIncome(dto.income);
    const fixed = buildFixed(dto.fixed);
    const flexible = buildFlexible(dto.flexible);
    // Build this object to calculate the totals
    const fixedOther = buildFixedOther(dto.fixedOther);
    const monthlySavingsAmount: number = toMoney(dto.monthlySavingsAmount);
    const debts = buildDebts(dto.debts);
    const mode = deriveFinancialStatementMode(dto.createdWhen as string);

    const totals = computeTotals(
      income,
      fixed,
      flexible,
      debts,
      fixedOther,
      monthlySavingsAmount,
    );
    const disposableIncome = calcDisposable(totals);
    const aboutYouCreated = createAboutYou(dto);

    return {
      // Keep this exposed until we tighten up the needed data from this raw object
      ...dto,
      disposableIncome,
      mode,
      income,
      fixed,
      fixedOther: dto.fixedOther,
      flexible,
      debts,
      monthlySavingsAmount,
      totals,
      aboutYou: aboutYouCreated,
    };
  }

  public static sendViewModel(
    dto: Omit<FinancialStatementView, "totals"> ,
  ): FinancialStatementResponseDto {
    return {
      ...dto,
      income: dumpSection(dto.income),
      fixed: dumpSection(dto.fixed),
      flexible: dumpSection(dto.flexible),
      fixedOther: dto.fixedOther,
      debts: dumpSection(dto.debts, true),
      monthlySavingsAmount: dto.monthlySavingsAmount,
      monthsSinceReview: 0,
    };
  }
}
